import { DAY_PASCAL, TARGET_AUDIENCE } from '../../constants/common';
import { INDEX } from './types';
import { DayLoadingAttributes } from './types';

const getDayLoading = (
  dayStratSheet: Array<Array<any>>,
  attributes: DayLoadingAttributes
) => {
  const row = getRowIndex(dayStratSheet, attributes.demographic);
  const column = getColumnIndex(dayStratSheet, attributes.day);
  return dayStratSheet[row][column];
};

const getRowIndex = (
  dayStratSheet: Array<Array<any>>,
  demographic: TARGET_AUDIENCE
): number => {
  return dayStratSheet.findIndex(
    (row: Array<any>) => row[INDEX.DEMOGRAPHIC] === demographic
  );
};

const getColumnIndex = (
  dayStratSheet: Array<Array<any>>,
  day: DAY_PASCAL
): number => {
  return dayStratSheet[INDEX.HEADER_ROW].indexOf(day);
};

export default getDayLoading;
